import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Certificates - INGAZ Print";

function Certificates() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Certificates" images={[asset('assets/certificates_hero.png'), asset('assets/certificates_angle.png'), asset('assets/certificates_stack.png'), asset('assets/certificates_hero.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Certificates" data-ar="الشهادات">Certificates</h1>
                <p className="product-description" data-en="Professional certificates and diplomas for recognition, awards, and achievements." data-ar="شهادات ودبلومات احترافية للتقدير والجوائز والإنجازات.">Professional certificates and diplomas for
                  recognition, awards, and achievements.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Prestige and recognition for recipients" data-ar="الهيبة والتقدير للمستلمين">
                      Prestige and recognition for recipients</li>
                    <li data-en="Premium paper with elegant finishes" data-ar="ورق فاخر مع تشطيبات أنيقة">
                      Premium paper with elegant finishes</li>
                    <li data-en="Customizable designs with foil stamping" data-ar="تصاميم قابلة للتخصيص مع ختم الفويل">
                      Customizable designs with foil stamping</li>
                    <li data-en="Professional look for any occasion" data-ar="مظهر احترافي لأي مناسبة">
                      Professional look for any occasion</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Awards" data-ar="الجوائز">Awards</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Training" data-ar="التدريب">Training</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Graduation" data-ar="التخرج">Graduation</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Employee Awards" data-ar="جوائز الموظفين">Employee Awards</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Certificates" data-ar="قم بتكوين الشهادات الخاصة بك">Configure Your Certificates</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A4" data-dims="210x297 mm">A4<br /><span>210x297</span></div>
                    <div className="size-option" data-size="A5" data-dims="148x210 mm">A5<br /><span>148x210</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="Custom" data-ar="مخصص">Custom</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-300" data-en="Couche 300 gsm" data-ar="كوشيه 300 جم">Couche 300 gsm</option>
                      <option value="fabriano-230" data-en="Fabriano 230 gsm" data-ar="فابريانو 230 جم">Fabriano 230 gsm</option>
                      <option value="crystal-silver-230" data-en="Crystal Silver 230 gsm" data-ar="كريستال فضي 230 جم">Crystal Silver 230 gsm</option>
                      <option value="crystal-white-230" data-en="Crystal White 230 gsm" data-ar="كريستال أبيض 230 جم">Crystal White 230 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printed Sides" data-ar="الجوانب المطبوعة">Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="Single side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Single side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double sides</span>
                    </div>
                  </div>
                </div>
                {/* Special Finishing */}
                <div className="config-group">
                  <label data-en="Special Finishing" data-ar="تشطيبات خاصة">Special Finishing</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="specialFinishing" defaultValue="none" defaultChecked onChange={(e) => document.getElementById('finishingNotesWrapper').style.display = 'none'} />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="specialFinishing" defaultValue="foil" onChange={(e) => document.getElementById('finishingNotesWrapper').style.display = 'block'} />
                      <span data-en="Foil stamping" data-ar="بصمة فويل">Foil stamping</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="specialFinishing" defaultValue="embossing" onChange={(e) => document.getElementById('finishingNotesWrapper').style.display = 'block'} />
                      <span data-en="Embossing" data-ar="بصمة بارزة">Embossing</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="specialFinishing" defaultValue="spot-uv" onChange={(e) => document.getElementById('finishingNotesWrapper').style.display = 'block'} />
                      <span data-en="Spot UV" data-ar="سبوت يو في">Spot UV</span>
                    </label>
                  </div>
                  
                  <div id="finishingNotesWrapper" style={{display: 'none', marginTop: '10px'}}>
                    <textarea id="finishingNotes" className="custom-size-input" placeholder="Please describe the finishing areas and whether finishing applies to one side or two sides" data-placeholder-en="Please describe the finishing areas and whether finishing applies to one side or two sides" data-placeholder-ar="يرجى وصف مناطق التشطيب وما إذا كان التشطيب ينطبق على جانب واحد أو جانبين" rows={2} style={{width: '100%', resize: 'vertical'}}></textarea>
                  </div>
                </div>
                {/* Personalization */}
                <div className="config-group">
                  <label data-en="Personalization" data-ar="التخصيص">Personalization</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="personalization" defaultValue="standard" defaultChecked onChange={(e) => document.getElementById('personalizationListUpload').style.display = 'none'} />
                      <span data-en="Standard (all the same)" data-ar="قياسي (نفس التصميم)">Standard (all the same)</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="personalization" defaultValue="personalized" onChange={(e) => document.getElementById('personalizationListUpload').style.display = 'block'} />
                      <span data-en="Personalized (different names/details)" data-ar="مخصص (أسماء وتفاصيل مختلفة)">Personalized (different names/details)</span>
                    </label>
                  </div>
                  
                  {/* Upload list for personalized */}
                  <div id="personalizationListUpload" style={{display: 'none', marginTop: '15px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px dashed #ced4da'}}>
                    <strong style={{display: 'block', marginBottom: '8px'}} data-en="Upload Names/Numbers List" data-ar="رفع قائمة الأسماء/الأرقام">Upload Names/Numbers List</strong>
                    <p style={{fontSize: '13px', color: '#6c757d', marginBottom: '10px'}} data-en="Please upload an Excel (.xlsx) or CSV file containing the list of names/details to be printed on each certificate." data-ar="يرجى رفع ملف Excel أو CSV يحتوي على قائمة الأسماء/التفاصيل التي ستُطبع على كل شهادة.">Please upload an Excel (.xlsx) or CSV file containing the list of names/details to be printed on each certificate.</p>
                    <input type="file" id="namesListFile" accept=".xlsx,.xls,.csv" style={{width: '100%'}} />
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                <NotesField />
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload Design Files" data-ar="رفع ملفات التصميم">Upload Design Files</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">A4</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Lamination:" data-ar="التغليف:">Lamination:</span>
                    <span className="summary-value" id="summaryLamination">None</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Personalization:" data-ar="التخصيص:">Personalization:</span>
                    <span className="summary-value" id="summaryPersonalization">Standard</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design
                    review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Certificates;
